<form class="inline-flex items-center">
	<label class="inline-flex items-center gap-3 cursor-pointer">
		<input
			type="checkbox"
			[checked]="isClearing()"
			id="clearing-toggle"
			name="clearing-toggle"
			(change)="updateValue($event)"
			class="sr-only peer"
		/>
		<span
			[ngClass]="{
				'after:bg-uc-blue-900 peer-checked:bg-uc-blue-100': isClearing(),
				'after:bg-white peer-checked:bg-gray-200': !isClearing(),
			}"
			class="block relative flex-shrink-0 w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all"
		></span>
		<span class="text-sm font-medium leading-5 text-nowrap" [ngClass]="customStyles()"
			>{{ isClearing() ? 'Disable' : 'Enable' }} Clearing Mode</span
		>
	</label>
</form>
